/** 列表/详情无图时的占位（与 PC、移动端商品页一致） */
const GOODS_IMG = require("@/assets/image/goods/goods_img.webp");

/**
 * 判断价格字段是否按「金额 + 円 + 税」展示（服务端多为字符串，需前端识别）。
 * 支持半角/全角数字、千分位（逗号/顿号/空格等）、小数点；含其它字符（如「円」「未定」）则视为纯文案。
 *
 * @param {unknown} value
 * @returns {boolean}
 */
export function isGoodsPriceNumericLike(value) {
    if (value === null || value === undefined) return false
    const raw = String(value).trim()
    if (!raw) return false

    const asciiDigits = raw.replace(/[\uFF10-\uFF19]/g, (ch) =>
        String.fromCharCode(ch.charCodeAt(0) - 0xff10 + 0x30),
    )
    const normalized = asciiDigits.replace(
        /[\s,，_'＿\u00a0\u2000-\u200b\u202f]/g,
        "",
    )

    if (!normalized) return false
    return /^-?\d+(\.\d+)?$/.test(normalized)
}

/** 将 goods-content.json 中 goodsList 条目转为运行时 img[]（接口失败且配置了兜底条目时使用） */
export function hydrateGoodsListFromContent(entries) {
    return entries.map((entry) => {
        const { imageCount, ...rest } = entry;
        const n = Math.max(1, Number(imageCount) || 1);
        return {
            ...rest,
            priceIsNumeric: isGoodsPriceNumericLike(rest.price),
            img: Array(n)
                .fill(null)
                .map(() => GOODS_IMG),
        };
    });
}

/** 解析配置平台 slideShow 为图片 URL 列表（支持数组 / JSON 字符串 / 分隔字符串） */
export function parseSlideShowUrls(slideShow) {
    if (slideShow == null || slideShow === "") return [];
    if (Array.isArray(slideShow)) {
        return slideShow.map(String).map((x) => x.trim()).filter(Boolean);
    }
    const s = String(slideShow).trim();
    if (!s) return [];
    if (s.startsWith("[")) {
        try {
            const arr = JSON.parse(s);
            if (Array.isArray(arr)) {
                return arr.map(String).map((x) => x.trim()).filter(Boolean);
            }
        } catch (_) {
            /* 非 JSON 则走下方分隔逻辑 */
        }
    }
    return s
        .split(/[,，\n|]/u)
        .map((x) => x.trim())
        .filter(Boolean);
}

/** 将 /api/web/content/list 的单条 row 转为列表与详情弹层使用的结构 */
export function mapGoodsRowToItem(row) {
    let img = parseSlideShowUrls(row.slideShow);
    if (!img.length) {
        img = [GOODS_IMG];
    }
    const titleStr = row.title != null ? String(row.title).trim() : "";
    const title = titleStr.includes("\n") ?
        titleStr
        .split(/\n/)
        .map((t) => t.trim())
        .filter(Boolean) :
        titleStr ? [titleStr] : [""];

    const detailsRaw = row.details != null ? String(row.details) : "";
    let info = [];
    if (detailsRaw) {
        const lines = detailsRaw
            .split(/\n/)
            .map((l) => l.trim())
            .filter(Boolean);
        info = lines.length ? lines : [detailsRaw];
    }
    // details 未入力時は詳細ページの説明欄(info)を空のままにする（title で埋めない）。
    // 一覧カードの説明(msg)は従来どおり info が空なら title で代替。

    const msg = info.length ? info.slice(0, 3) : [...title];

    const priceStr = row.price != null ? String(row.price) : "";

    // 購入制限の本文（后端字段 mes1）。前缀は前端固定、本文のみ后端値を使用。
    const limitBody = row.mes1 != null ? String(row.mes1).trim() : "";

    return {
        id: row.id,
        title,
        info,
        msg,
        price: priceStr,
        priceIsNumeric: isGoodsPriceNumericLike(row.price),
        img,
        link: row.link,
        limit: row.limit === true || row.limit === 1 || row.limit === "1" || row.limit === "true",
        limitBody,
    };
}